import styled from 'styled-components';
import { colors } from 'pages/Quotes/styles/colors';

export const ScrollToTopButtonContainer = styled.div`
  position: fixed;
  display: flex;
  left: calc(50% - 95px);
  top: 10px;

  width: 100%;
  z-index: 1;
`;

export const ScrollToTopButton = styled.button`
  display: flex;  
  width: 190px;
  height: 40px;
  gap: 10px;

  justify-content: center;
  align-items: center;
  border-radius: 5px;
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.3);

  background-color: ${colors.viveoDarkBlue};
  color: ${colors.white};
  cursor: pointer;
`;